import React from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';

const urgencyLabel = (u) => {
  const x = (u || '').toLowerCase();
  if (x === 'high') return { label: 'High concern', color: 'warning' };
  if (x === 'medium') return { label: 'Medium concern', color: 'info' };
  return { label: 'Low concern', color: 'success' };
};

/**
 * Renders a grounded assistant turn: main reply text, optional urgency, numbered steps.
 * Sections are gated by structured.show* flags (server-driven) to avoid clutter.
 */
const AssistantMessageBody = ({ text, structured }) => {
  const {
    urgency,
    steps,
    explanation,
    why_it_matters,
    showUrgencyChip,
    showExplanation,
    showWhy,
    showSteps,
  } = structured || {};

  const chipOn = showUrgencyChip && urgency;
  const chip = chipOn ? urgencyLabel(urgency) : null;
  const stepsOn = showSteps && steps && steps.length > 0;
  const explainOn = showExplanation && explanation;
  const whyOn = showWhy && why_it_matters;

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {text}
      </Typography>

      {chip && (
        <Chip
          size="small"
          label={chip.label}
          color={chip.color}
          sx={{
            mt: 1.1,
            fontWeight: 600,
            ...(chip.color === 'info' ? { bgcolor: 'rgba(96, 165, 250, 0.18)', color: '#E6EDF7' } : {}),
          }}
        />
      )}

      {stepsOn && (
        <Box sx={{ mt: 1.35 }}>
          <Typography variant="caption" sx={{ color: 'rgba(230, 237, 247, 0.75)', fontWeight: 600, display: 'block', mb: 0.65 }}>
            Next steps
          </Typography>
          <Box component="ol" sx={{ m: 0, pl: 2.25, color: '#E6EDF7', '& li': { mb: 0.65, fontSize: '0.875rem', lineHeight: 1.55 } }}>
            {steps.map((s, i) => (
              <Typography key={i} component="li" variant="body2">
                {s}
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {(explainOn || whyOn) && (
        <Box sx={{ mt: 1.35 }}>
          <Divider sx={{ borderColor: 'rgba(148, 163, 184, 0.2)', mb: 1 }} />
          {explainOn ? (
            <Typography variant="caption" sx={{ color: 'rgba(230, 237, 247, 0.82)', display: 'block', mb: whyOn ? 0.85 : 0 }}>
              {explanation}
            </Typography>
          ) : null}
          {whyOn ? (
            <Typography variant="caption" sx={{ color: 'rgba(230, 237, 247, 0.78)', display: 'block' }}>
              {why_it_matters}
            </Typography>
          ) : null}
        </Box>
      )}
    </Box>
  );
};

export default AssistantMessageBody;
